import { render } from "./newPassword.vue?vue&type=template&id=43b9dc18&scoped=true"
import script from "./newPassword.vue?vue&type=script&lang=js"
export * from "./newPassword.vue?vue&type=script&lang=js"

import "./newPassword.vue?vue&type=style&index=0&id=43b9dc18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b9dc18"]])

export default __exports__